import { Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export function Dashboard() {
  const { user } = useAuth()

  return (
    <div>
      <h1 className="text-2xl font-heading font-bold text-text mb-2">
        Welcome, {user?.firstName}
      </h1>
      <p className="text-text-light mb-8">
        {user?.duesPd ? (
          <span className="text-success">Dues are current</span>
        ) : (
          <span className="text-error">Dues are past due</span>
        )}
        {user?.duesPdDate && <span className="text-text-muted ml-2">(paid {user.duesPdDate})</span>}
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <DashboardCard
          to="/dues"
          title="Pay Dues"
          description="Renew your AU membership"
          urgent={!user?.duesPd}
        />
        <DashboardCard
          to="/bands"
          title="Order Bands"
          description="Personalized band ordering (Oct–Mar)"
        />
        <DashboardCard
          to="/bands/stock"
          title="Stock Bands"
          description="Order stock bands (year-round)"
        />
        <DashboardCard
          to="/profile"
          title="My Profile"
          description="Update your contact information"
        />
        <DashboardCard
          to="/races"
          title="My Races"
          description="View your race results and awards"
        />
        <DashboardCard
          to="/directory"
          title="Member Directory"
          description="Search the AU membership"
        />
        <DashboardCard
          to="/band-listings"
          title="Band Listings"
          description="Look up who a band series belongs to"
        />
      </div>
    </div>
  )
}

function DashboardCard({ to, title, description, urgent }: {
  to: string
  title: string
  description: string
  urgent?: boolean
}) {
  return (
    <Link
      to={to}
      className={`
        block p-6 rounded-lg border transition-all hover:shadow-md
        ${urgent
          ? 'border-error bg-error/5 hover:border-error/80'
          : 'border-border bg-surface hover:border-primary/30'
        }
      `}
    >
      <h2 className="font-heading font-semibold text-lg text-text mb-1">{title}</h2>
      <p className="text-text-muted text-sm">{description}</p>
      {urgent && <span className="inline-block mt-2 text-xs font-medium text-error">Action needed</span>}
    </Link>
  )
}
